import { combineEntries } from "../economy/entries.js";
import { progressionContext } from "./context.js";
export function upgradeCommand(upgrade) {
    return { id: `upgrade:${upgrade.id}`, execute: (tx) => executeUpgrade(upgrade, tx) };
}
function executeUpgrade(upgrade, transaction) {
    if (!transaction.isScopeActive(upgrade.scope))
        transaction.reject({ code: "disabled", actionId: upgrade.id, reasonKey: "scope-inactive" });
    if (transaction.hasProgress("upgrade", upgrade.id)) {
        transaction.reject({ code: "disabled", actionId: upgrade.id, reasonKey: "already-owned" });
    }
    if (!upgrade.unlocked(progressionContext(transaction))) {
        transaction.reject({ code: "locked", prerequisiteIds: upgrade.prerequisiteIds });
    }
    const costs = combineEntries(upgrade.costs, transaction.numbers);
    for (const [resource, required] of costs) {
        const available = transaction.get(resource);
        if (transaction.numbers.cmp(available, required) < 0) {
            transaction.reject({ code: "insufficient", resourceId: resource.id, required, available });
        }
    }
    for (const [resource, required] of costs) {
        transaction.add(resource, transaction.numbers.sub(transaction.numbers.fromNumber(0), required));
    }
    transaction.setProgress("upgrade", upgrade.id);
    upgrade.apply?.(transaction);
}
export function resolveTriggers(transaction, definitions) {
    const ordered = [...definitions].sort(compareTriggers);
    let changed = true;
    while (changed) {
        changed = false;
        for (const definition of ordered) {
            if (!transaction.isScopeActive(definition.scope))
                continue;
            if (transaction.hasProgress(definition.kind, definition.id))
                continue;
            if (!definition.when(progressionContext(transaction)))
                continue;
            transaction.setProgress(definition.kind, definition.id);
            definition.apply?.(transaction);
            changed = true;
        }
    }
}
export function resolveWin(transaction, win) {
    if (win?.(progressionContext(transaction)))
        transaction.setWon(true);
}
function compareTriggers(left, right) {
    if (left.priority !== right.priority)
        return left.priority - right.priority;
    if (left.kind !== right.kind)
        return left.kind === "milestone" ? -1 : 1;
    return left.id < right.id ? -1 : left.id > right.id ? 1 : 0;
}
//# sourceMappingURL=features.js.map